/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Data_RetryInputs */

const vi_station_data_retry = /** @type {(inputs: Station_Data_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật lại danh sách đơn`)
};

/**

* @param {Station_Data_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_data_retry = /** @type {((inputs?: Station_Data_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Data_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_data_retry(inputs)
});